import { useCallback, useState } from "react";
import { UpdateConfirmationDialog } from "./UpdateConfirmationDialog/UpdateConfirmationDialog";
import { UpdateSuccessDialog } from "./UpdateSuccessDialog/UpdateSuccessDialog";
import { UpdateFailDialog } from "./UpdateFailDialog/UpdateFailDialog";

export type UpdateWizardProps = {
	onClose: () => void;
	onUpdateSuccess: () => void;
};

enum DialogSteps {
	Confirmation = 0,
	Success = 1,
	Fail = 2,
	Azure = 3
}

export const UpdateWizard = (props: UpdateWizardProps) => {
	const { onClose, onUpdateSuccess } = props;

	const [currentStep, setCurrentStep] = useState<DialogSteps>(DialogSteps.Confirmation);
	const [errorMessage, setErrorMessage] = useState<string>("");
	const [adminConsentUrl, setAdminConsentUrl] = useState<string>("");

	const showConfirmation = useCallback(
		(): void => {
			setCurrentStep(DialogSteps.Confirmation);
		},
		[]);

	const showSuccess = useCallback(
		(consentUrl: string): void => {
			setCurrentStep(DialogSteps.Success);
			setAdminConsentUrl(consentUrl);
			onUpdateSuccess();
		},
		[onUpdateSuccess]);

	const showFail = useCallback(
		(message: string): void => {
			setErrorMessage(message);
			setCurrentStep(DialogSteps.Fail);
		},
		[]
	);

	switch (currentStep) {
		case DialogSteps.Confirmation:
			return (
				<UpdateConfirmationDialog
					onSuccess={showSuccess}
					onFail={showFail}
					onCancel={onClose}
				/>
			);
		case DialogSteps.Success:
			return <UpdateSuccessDialog onClose={onClose} consentUrl={adminConsentUrl} />;
		case DialogSteps.Fail:
			return (
				<UpdateFailDialog
					onBack={showConfirmation}
					onClose={onClose}
					onSuccess={showSuccess}
					reason={errorMessage}
				/>
			);
		default:
			return (
				<UpdateConfirmationDialog
					onSuccess={showSuccess}
					onFail={showFail}
					onCancel={onClose}
				/>
			);
	}
};

UpdateWizard.displayName = "UpdateWizard";
